














/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable class-methods-use-this */
import Component from 'vue-class-component';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import MapUserList from '@/components/maplist/MapUserList.vue';
import AlertPanel from '@/components/shared/AlertPanel.vue';
import BaseComponent from '@/components/BaseComponent';
import {  EVENTS } from '@/services/EventBus';

// eslint-disable-next-line no-use-before-define
@Component<MapList>({
  props: {
  },
  watch: {
    $route(to, from) {
      this.routeChange(to, from);
    },
  },
  components: {
    Header,
    Footer,
    MapUserList,
    AlertPanel,

  },
})
export default class MapList extends BaseComponent {
  mapKeywordFilter='';

  mounted() {
    if (this.contextService.configLoaded) {
      this.onConfigLoaded(this.contextService.configuration);
    } else {
      this.getEventBus().$on(EVENTS.CONFIG_LOADED, (config:any) => this.onConfigLoaded(config));
    }
  }

  routeChange(to:any, from:any) {
    console.log(to, from);
    this.onConfigLoaded(this.contextService.configuration);
  }

  onConfigLoaded(config:any) {
    console.log(this.$route);

    const showHeader = this.$route.query.header;

    const mapKeywordFilter:any = this.$route.query.kw;

    if (mapKeywordFilter !== undefined) {
      this.mapKeywordFilter = mapKeywordFilter;
    }

    if (showHeader !== undefined && showHeader === 'false') {
      this.contextService.showHeader = false;
    }

    const showFooter = this.$route.query.footer;
    if (showFooter !== undefined && showFooter === 'false') {
      this.contextService.showFooter = false;
    }
  }
}

